import React, { useState } from "react";
// redux
import { useSelector, useDispatch } from "react-redux";
import {
  approveClaim,
  dismissClaim,
} from "../../redux/actions/ClaimActions.js";
//react components for routing our app without refresh
// import { useParams } from "react-router";
import { useParams, Link, useHistory } from "react-router-dom";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { Grid } from "@material-ui/core";
// @material-ui/icons
import Close from "@material-ui/icons/Close";
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Parallax from "components/Parallax/Parallax.js";
// other
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-kit-react/views/components.js";
import { formatDateTime, Transition } from "utils.js";

const useStyles = makeStyles(styles);

export default function ClaimDetailPage() {
  const classes = useStyles();
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );

  const dispatch = useDispatch();
  const history = useHistory();
  const { claimerUsername, foundItemId } = useParams();
  const claimRequest = useSelector(
    (state) =>
      state.claimRequests.filter(
        (claimRequestItem) =>
          claimRequestItem.claimerUsername === claimerUsername &&
          claimRequestItem.foundItemId === foundItemId
      )[0]
  );
  const [approveModal, setApproveModal] = useState(false);

  const handleApprove = () => {
    setApproveModal(false);
    approveClaim(dispatch, history, {
      userId: claimerUsername,
      foundId: foundItemId,
    });
  };

  const handleDismiss = () => {
    dismissClaim(dispatch, history, {
      userId: claimerUsername,
      foundId: foundItemId,
    });
  };

  return (
    <div>
      <Header
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 200,
          color: "white",
        }}
      />
      <Parallax small filter image={require("assets/img/bg4.jpg")}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <h1 className={classes.title}>Claim Requests</h1>
                <h3 className={classes.subtitle}>
                  Manage the claim requests of the users.
                </h3>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div className={classNames(classes.main, classes.mainRaised)}>
        <GridContainer className={classes.container}>
          <GridItem xs={12} md={6} className="my-5">
            <img
              src={claimRequest?.imageId}
              alt="claim deteil"
              width="100%"
              className={imageClasses}
            />
          </GridItem>
          <GridItem xs={12} md={6} className="my-5">
            <Table className="minWidth: 650" aria-label="simple table">
              <TableBody>
                <TableRow>
                  <TableCell align="right">Item Name</TableCell>
                  <TableCell align="left">{claimRequest?.itemName}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Description</TableCell>
                  <TableCell align="left">
                    {claimRequest?.description}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Requested By</TableCell>
                  <TableCell align="left">
                    {" "}
                    <Link to={"/users/" + claimRequest?.claimerUsername}>
                      {claimRequest?.claimerUsername}
                    </Link>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Found Location</TableCell>
                  <TableCell align="left">{claimRequest?.location}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Found on</TableCell>
                  <TableCell align="left">
                    {formatDateTime(claimRequest?.foundTimestamp)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Posted on</TableCell>
                  <TableCell align="left">
                    {formatDateTime(claimRequest?.createdAt)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Updated on</TableCell>
                  <TableCell align="left">
                    {formatDateTime(claimRequest?.updatedAt)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>

            <br />
            <Grid
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
            >
              <Grid item xs={12} md={6}>
                <Button
                  onClick={() => setApproveModal(true)}
                  round
                  color="success"
                >
                  Approve
                </Button>
              </Grid>
              <Grid item xs={12} md={6}>
                <Button onClick={handleDismiss} round color="danger">
                  Dismiss
                </Button>
              </Grid>
            </Grid>

            <Dialog
              classes={{
                root: classes.center,
                paper: classes.modal,
              }}
              open={approveModal}
              TransitionComponent={Transition}
              keepMounted
              onClose={() => setApproveModal(false)}
              aria-labelledby="approve-modal-slide-title"
              aria-describedby="approve-modal-slide-description"
            >
              <DialogTitle
                id="approve-modal-slide-title"
                disableTypography
                className={classes.modalHeader}
              >
                <IconButton
                  className={classes.modalCloseButton}
                  key="close"
                  aria-label="Close"
                  color="inherit"
                  onClick={() => setApproveModal(false)}
                >
                  <Close className={classes.modalClose} />
                </IconButton>
                <h4 className={classes.modalTitle}>Approve Claim Request</h4>
              </DialogTitle>
              <DialogContent
                id="approve-modal-slide-description"
                className={classes.modalBody}
              >
                <p>Are you sure you want to approve this claim request?</p>
              </DialogContent>
              <DialogActions className={classes.modalFooter}>
                <Button onClick={handleApprove} color="success" simple>
                  Yes
                </Button>
                <Button
                  onClick={() => setApproveModal(false)}
                  color="transparent"
                  simple
                >
                  No
                </Button>
              </DialogActions>
            </Dialog>
          </GridItem>
        </GridContainer>
      </div>
      <Footer />
    </div>
  );
}
